import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { EditConfigurationComponent } from "./components/edit-configuration/edit-configuration.component";
import { ListConfigurationsComponent } from "./components/list-configurations/list-configurations.component";
import { ConnectionsModule } from "./connections/connections.module";
import { ConfigurationExistsGuard } from "./guards/configuration-exists.guard";
import { StatusGuard } from "./guards/status.guard";
import { LogsModule } from "./logs/logs.module";
import { OverwriteFolderPermissionsModule } from "./overwrite-folder-permissions/overwrite-folder-permissions.module";
import { SettingsModule } from "./settings/settings.module";
import { SharePointStructureCreatorModule } from "./sharepoint-structure-creator/sharepoint-structure-creator.module";
import { WizardModule } from "./wizard/wizard.module";

const routes: Routes = [
  {
    path: "",
    component: ListConfigurationsComponent
  },
  {
    path: "create",
    loadChildren: () => WizardModule
  },
  {
    path: ":instance-id",
    canActivate: [ConfigurationExistsGuard],
    children: [
      {
        path: "",
        component: EditConfigurationComponent
      },
      {
        path: "logs",
        loadChildren: () => LogsModule
      },
      {
        path: "connections",
        loadChildren: () => ConnectionsModule
      },
      {
        path: "overwrite-folder-permissions",
        loadChildren: () => OverwriteFolderPermissionsModule,
        canActivate: [StatusGuard]
      },
      {
        path: "sharepoint-structure-creator",
        loadChildren: () => SharePointStructureCreatorModule        
      },
      {
        path: "settings",
        loadChildren: () => SettingsModule
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigurationRoutingModule {}
